const getLocale = (state) => state.getIn(['intl', 'activeLocale']);

export default getLocale;
